import * as yup from "yup";

export const passwordValidator = yup.string().required("Password is required");

export const nameValidator = yup
  .string()
  .max(50, "Field length must be less or equal to 50")
  .matches(/^[A-Za-z0-9_]*$/, "Don't use specific symbols")
  .required("Field is required");

export const pushCenterNameValidator = yup
  .string()
  .max(50, "Field length must be less or equal to 50")
  .matches(/^[A-Za-z0-9_.-]*$/, "Don't use specific symbols")
  .required("Field is required");

export const notRequiredDescriptionValidator = yup
  .string()
  .matches(/^[A-Za-z0-9 #_.-]*$/, "Don't use specific symbols");

export const descriptionValidator =
  notRequiredDescriptionValidator.required("Field is required");

export const emailValidation = yup.string().email().label("Email").required();

export const usernameValidator = (fieldName) =>
  yup
    .string()
    .max(50, "Field length must be less or equal to 50")
    .matches(
      /^[A-Za-z0-9_-]*$/,
      "Use only letters, numbers, underscores or hyphens.",
    )
    .required(`${fieldName} is required`);

export const createEditPatchTagValidator = yup.object({
  patchTag: yup.string().required("Field is required"),
});

export const accountSystemNameValidator = yup
  .string()
  .max(30, "Field length must be less or equal to 30")
  .matches(/^[A-Za-z0-9_ ]*$/, "Don't use specific symbols")
  .required("Field is required");
